import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { fetchSubsPut } from '../../../../redux/reducers/SubsPutSlice'
import { sortedPriceObjects } from '../../Sorting/Sorting'
import style from './PriceDefaultBlock.module.scss'
const PriceDefaultBlock = ({ data, sub, statusSub, owner }) => {
	const { t } = useTranslation()
	console.log('data', data, sub, statusSub)
	const dispatch = useDispatch()
	const [indexY, setIndexY] = useState(0)

	const [clickedTypePrice, setClickedTypePrice] = useState({
		24: false,
		48: false,
		72: false,
		0: false,
		1: false,
		2: false,
	})

	const handleClickedTypePrice = (key, index) => {
		setClickedTypePrice(prevState => {
			setIndexY(index)
			// Сначала создаем новый объект состояния, где все ключи устанавливаются в false
			let newState = {
				24: false,
				48: false,
				72: false,
				0: false,
				1: false,
				2: false,
			}
			// Устанавливаем значение true только для кнопки, на которую был сделан клик
			newState[key] = true
			return newState
		})
	}
	useEffect(() => {
		sortedPriceObjects(data.priceObjects).map((time, index) => {
			if (time.time === 24) {
				handleClickedTypePrice(time.time, index)
			}
		})
	}, [data])
	//	sortedPriceObjects(dat.priceObjects)
	return (
		<div className={style.wrapperRootPriceSwitcher}>
			<div className={style.wrapperTitle}>
				<span>{t('buyAdverPriceBlock')}</span>
			</div>
			<div className={style.wrapperDefaultPrice}>
				<span>
					{Number(
						sortedPriceObjects(data.priceObjects)[indexY].price
					).toLocaleString('ru-RU', {
						style: 'currency',
						currency: 'RUB',
						minimumFractionDigits: 0,
					})}
				</span>
			</div>
			<div className={style.wrapperPriceType}>
				<div className={style.priceType}>
					{sortedPriceObjects(data.priceObjects).map(
						(time, index) =>
							time.hot === false && (
								<button
									key={index}
									className={
										clickedTypePrice[time.time]
											? style.clickedBtn
											: style.nonClickedButton
									}
									onClick={() => handleClickedTypePrice(time.time, index)}
								>
									{time.time === 24 && '1/24'}
									{time.time === 48 && '1/48'}
									{time.time === 72 && '1/72'}
									{time.time === 0 && `${t('nativ')}`}
									{time.time === 1 && `${t('repost')}`}
									{time.time === 2 && `${t('withoutRemove')}`}
									{time.hot_date}
								</button>
							)
					)}
				</div>
			</div>
			<div className={style.wrapperByBtn}>
				<button className={style.BtnBuy}>
					<a href={`https://t.me/${owner}`} target='_blank'>
						{t('buy')}
					</a>
				</button>
			</div>
			<button
				onClick={() => {
					dispatch(fetchSubsPut(data.id))
				}}
				className={style.wrapperHotTitle}
			>
				<span>
					{statusSub === 'success'
						? `${t('unsubscribeHot')}`
						: `${t('subscribeHot')}`}
				</span>
			</button>
		</div>
	)
}

export default PriceDefaultBlock
